import { View } from '@react-pdf/renderer';
import React from 'react';
import type { MyListPageItem } from './MyList';
import { Text } from './Text';

export default function Header({ exhibitor }: { exhibitor: MyListPageItem }) {
  return (
    <View style={{ flexDirection: 'row', height: 25 }}>
      <View
        style={{
          backgroundColor: 'black',
          padding: 3,
          justifyContent: 'center',
          alignItems: 'center',
          width: 100,
          marginRight: 10,
          flexShrink: 0,
          flexGrow: 0,
        }}
      >
        <Text style={{ color: 'white', fontSize: 14 }}>
          {exhibitor?.stand?.name}
        </Text>
      </View>
      <View
        style={{
          borderBottom: 1,
          borderBottomColor: '#CCC',
          flexShrink: 0,
          flexGrow: 0,
        }}
      >
        <Text variant="bold" style={{ fontSize: 16 }}>
          {exhibitor.name}
        </Text>
      </View>
    </View>
  );
}
